var _linearGradient, _linearGradient2, _linearGradient3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b47f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 6.92308,
    x2: 40.7382,
    xlinkHref: "#a",
    y1: 19.5193,
    y2: -22.0954
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 8.57312,
    x2: 13.7193,
    xlinkHref: "#a",
    y1: 11.5567,
    y2: -4.8409
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 7c0-2.20914 1.79086-4 4-4h12c2.2091 0 4 1.79086 4 4v10c0 2.2091-1.7909 4-4 4h-12c-2.20914 0-4-1.7909-4-4z",
    fill: "url(#b)",
    opacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m5.37604 7.58405c.22977-.34464.69542-.43777 1.04006-.20801l3.7812 2.5208c1.0917.72776 2.5139.72776 3.6056 0l3.7812-2.5208c.3446-.22976.8103-.13663 1.04.20801.2298.34465.1367.8103-.208 1.04007l-3.7812 2.52078c-1.5955 1.0637-3.6741 1.0637-5.26965 0l-3.7812-2.52078c-.34464-.22977-.43777-.69542-.20801-1.04007z",
    fill: "url(#c)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.762fecc774887783e36269c00568fc0c.svg";
export { ForwardRef as ReactComponent };